import type { AltApplication } from '@repo/alt/package'

import type { PlatformLaunchPayload } from './ports/types'
import { PLATFORM_PAYLOAD } from './tokens'

type NuxtAppLike = {
  $alt?: unknown
  $platformPayload?: PlatformLaunchPayload
}

/**
 * Rebind launch payload for DI, Nuxt `$platformPayload`, and (dev) `window`.
 * Shared by the platform plugin and gate retry so both stay in sync.
 */
export function bindPlatformPayload(
  nuxtApp: NuxtAppLike,
  payload: PlatformLaunchPayload,
) {
  const alt = nuxtApp.$alt as AltApplication | undefined
  if (alt?.container) {
    if (alt.container.isBound(PLATFORM_PAYLOAD)) {
      alt.container.rebindSync(PLATFORM_PAYLOAD).toConstantValue(payload)
    }
    else {
      alt.container.bind(PLATFORM_PAYLOAD).toConstantValue(payload)
    }
  }

  nuxtApp.$platformPayload = payload

  if (import.meta.dev && typeof window !== 'undefined') {
    ;(window as Window & { __platformPayload?: PlatformLaunchPayload })
      .__platformPayload = payload
  }
}
